import { FC, ReactNode, useRef } from 'react'
import cn from 'classnames'
import { IconButton, MinusIcon, PlusIcon, Text } from '@instabox/consumer-web-ui'

import styles from './collapsibleSubCategory.module.scss'

export interface CollapsibleSubCategoryProps {
  label: string
  expanded: boolean
  onToggle: () => void
  children?: ReactNode | undefined
}

const CollapsibleSubCategory: FC<CollapsibleSubCategoryProps> = ({
  label,
  expanded,
  onToggle,
  children,
}) => {
  const buttonRef = useRef<HTMLButtonElement>()
  return (
    <div className={cn(expanded && styles.withBorder)}>
      <div className={styles.header} onClick={() => buttonRef.current?.click()}>
        <Text as="span" fontWeight="medium">
          {label}
        </Text>
        <IconButton
          size="small"
          label={expanded ? 'collapse' : 'expand'}
          icon={expanded ? <MinusIcon /> : <PlusIcon />}
          variant={expanded ? 'primary' : 'secondary'}
          ref={buttonRef}
          onClick={e => {
            e.stopPropagation()
            onToggle()
          }}
        />
      </div>
      {expanded && <div className={styles.content}>{children}</div>}
    </div>
  )
}

export default CollapsibleSubCategory
